module.exports = __webpack_public_path__ + "webfolder/assets/ebook/ytt-magazine/issue-2/ar/img/MomentsOfPleasure-InlineImage.9a21935e.jpg";